
const UsersIcon = ({ color = "var(--primary-color)", width, height, ...props}) => (
    <svg    
        viewBox="0 0 20 20"
        width={width || 20}
        height={height || 20}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
    >
        <path
        stroke={`${color}`}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.72}
        strokeWidth={1.5}
        d="M17.327 8.218a1.686 1.686 0 1 1-2.384 2.384 1.686 1.686 0 0 1 2.384-2.384M11.835 5.209a2.596 2.596 0 1 1-3.67 3.671 2.596 2.596 0 0 1 3.67-3.671M5.057 8.218a1.686 1.686 0 1 1-2.384 2.384 1.686 1.686 0 0 1 2.384-2.384M19.167 16.115v-.913c0-1.15-.933-2.083-2.084-2.083h-.667M.833 16.115v-.913c0-1.15.933-2.083 2.084-2.083h.667M14.449 16.115v-1.334a2.917 2.917 0 0 0-2.917-2.917H8.466a2.917 2.917 0 0 0-2.916 2.917v1.334"
        />
    </svg>
)

export default UsersIcon
